import { InjectableClass } from '@fino/lib-injection';

export class UiModalDeclarationController extends InjectableClass {
  constructor($scope, $transclude, uiModalDeclarationService) {
    'ngInject';
    super({ $scope, $transclude, uiModalDeclarationService });

  }

  $onInit() {
    const {
      $transclude,
      $scope,
      modalKey,
      fullscreen,
      modalClass,
      onSuccess,
      onDissmis,
      uiModalDeclarationService,
      modalUrl
    } = this;

    //use parent scope as modals scope. this way it is possible to directly use variables defined
    //in parents scope controller in modals html. no need for using resolve.
    const scope = $scope.$parent;
    const options = {
      fullscreen,
      modalClass,
      onSuccess,
      onDissmis,
      scope
    };

    if (modalUrl) {
      return uiModalDeclarationService.registerWithUrl(
        modalKey,
        modalUrl,
        options
      );
    }

    uiModalDeclarationService.registerWithHtml(
      modalKey,
      $transclude(scope, null, null, 'content'),
      $transclude(scope, null, null, 'actions'),
      options
    );
  }
}
